module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8421/img/spinner.png"